import EntityTable from "@mirage/components/entityTable/EntityTable";
import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import PlanningApplicationsService from "@publicPortal/services/PlanningApplicationsService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { Filter, FilterItem } from "@shared/mirage/entityTable/Filter";
import "../PlanningApplication.css";
import { useCallback } from "react";

interface PAConstraintsTabContentProps {
    paId: number;
    service: PlanningApplicationsService;
}

const PAConstraintsTabContent = (props: PAConstraintsTabContentProps) => {
    const onGeneralConstraintsPageRequest = useCallback(
        async (pageRequest: IEntityPageRequest) => {
            return await props.service.generalConstraintsPageRequest(pageRequest);
        },
        [props.service]
    );

    const onPlanningConstraintsPageRequest = useCallback(
        async (pageRequest: IEntityPageRequest) => {
            return await props.service.planningConstraintsPageRequest(pageRequest);
        },
        [props.service]
    );

    const getFilter = () => {
        const filter = { parts: [] } as Filter;
        const filterItems: FilterItem[] = [];
        filterItems.push({ columnName: "paId", operator: "=", value: props.paId });
        filter.parts.push({ filterItems: filterItems });

        return filter;
    };

    const columns: GridColDef[] = [
        { field: "constraintCode", headerName: "Code", flex: 0.25 },
        { field: "name", headerName: "Name", flex: 0.25 },
        { field: "details", headerName: "Details", flex: 1 },
        { field: "fieldValue", headerName: "Value", flex: 1 },
    ];

    return (
        <Box>
            <EntityTable
                title="General Constraints"
                key="general-constraints-entityTable"
                stateKey="general-constraints-entityTable"
                onPageRequest={onGeneralConstraintsPageRequest}
                columns={columns}
                filter={getFilter()}
                rowHeight={30}
                columnHeaderHeight={40}
                noRecordsImage={false}
                toolbarOptions={{ disableFilter: true }}
            />
            <EntityTable
                title=" Planning Policy Constraints"
                key="planning-constraints-entityTable"
                stateKey="planning-constraints-entityTable"
                onPageRequest={onPlanningConstraintsPageRequest}
                columns={columns}
                filter={getFilter()}
                rowHeight={30}
                columnHeaderHeight={40}
                noRecordsImage={false}
                toolbarOptions={{ disableFilter: true }}
            />
        </Box>
    );
};

export default PAConstraintsTabContent;
